<template>
  <sdf-button ref="buttonRef" class="relative" v-bind="$props">
    <slot></slot>
  </sdf-button>
</template>

<script setup lang="ts">
import type { JSX } from '@waypoint/web-components';
import { useTemplateRef } from 'vue';
import type { SdfButtonSlots } from '@/waypoint-vue-wrappers/types/slots';

defineOptions({
  name: 'SdfButton',
});

defineProps<Partial<JSX.SdfButton>>();
defineSlots<SdfButtonSlots>();

type SdfButtonElement = HTMLElement & {
  setFocus?: () => Promise<void>;
};

const buttonRef = useTemplateRef<SdfButtonElement>('buttonRef');

const setFocus = async () => {
  await buttonRef.value?.setFocus?.();
};

defineExpose({
  setFocus,
});
</script>
